// src/utils/results/resultModeConfig.js

import { RECORDING_MODES } from "../recordingModes";

export const RESULT_VARIANTS = {
  SPIROMETRY: "RecordingSpirometry",
  CARDIOPULMONARY: "RecordingTidalBreathing",
  MANUAL_AUDIO: "RecordingManualAudio",
  POST_EXERTION: "RecordingPostExertion",
};

export const RESULT_CONTEXTS = {
  SPIROMETRY: "spirometry",
  CARDIOPULMONARY: "cardiopulmonary",
  MANUAL_AUDIO: "manual-audio",
  POST_EXERTION: "post-exertion",
};

export const RESULT_TABS = {
  SPIROMETRY: "spiro",
  CARDIOPULMONARY: "cardiopulmonary",
  MANUAL_AUDIO: "manual-audio",
  POST_EXERTION: "post-exertion",
};

export const RESULT_MODE_CONFIG = {
  spirometry: {
    mode: RECORDING_MODES.SPIROMETRY,
    variant: RESULT_VARIANTS.SPIROMETRY,
    context: RESULT_CONTEXTS.SPIROMETRY,
    tab: RESULT_TABS.SPIROMETRY,
    collectionName: RESULT_VARIANTS.SPIROMETRY,
    resetKey: "spiro",
  },

  cardiopulmonary: {
    mode: RECORDING_MODES.TIDAL,
    variant: RESULT_VARIANTS.CARDIOPULMONARY,
    context: RESULT_CONTEXTS.CARDIOPULMONARY,
    tab: RESULT_TABS.CARDIOPULMONARY,
    collectionName: RESULT_VARIANTS.CARDIOPULMONARY,
    resetKey: "cardiopulmonary",
  },

  manualAudio: {
    mode: RECORDING_MODES.MAUDIO,
    variant: RESULT_VARIANTS.MANUAL_AUDIO,
    context: RESULT_CONTEXTS.MANUAL_AUDIO,
    tab: RESULT_TABS.MANUAL_AUDIO,
    collectionName: RESULT_VARIANTS.MANUAL_AUDIO,
    resetKey: RESULT_VARIANTS.MANUAL_AUDIO,
  },

  postExertion: {
    mode: RECORDING_MODES.POSTEXERTION,
    variant: RESULT_VARIANTS.POST_EXERTION,
    context: RESULT_CONTEXTS.POST_EXERTION,
    tab: RESULT_TABS.POST_EXERTION,
    collectionName: RESULT_VARIANTS.POST_EXERTION,
    resetKey: RESULT_VARIANTS.POST_EXERTION,
  },
};
